import { getLocale } from "../runtime";

const da_errortitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Noget gik galt`
};

const en_errortitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Something Went Wrong`
};

const es_errortitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Algo salió mal`
};

const fi_errortitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Jokin meni pieleen`
};

const nb_errortitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Noe gikk galt`
};

const sv_errortitle = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Något gick fel`
};

const errortitle = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_errortitle(inputs)
	if (locale === "en") return en_errortitle(inputs)
	if (locale === "es") return es_errortitle(inputs)
	if (locale === "fi") return fi_errortitle(inputs)
	if (locale === "nb") return nb_errortitle(inputs)
	if (locale === "sv") return sv_errortitle(inputs)
	return "errorTitle";
};

export { errortitle as "errorTitle" };